import * as yup from 'yup';
import { NAME_MAX, personName, phoneNumber, TranslateFn } from '../../../library/validationRules';
import ResourcesIds from '../../../resources/ResourcesIds';

/**
 * What a signed-in user may change about themselves. The address is not here: it is the
 * account identity and the API refuses to move it.
 *
 * The phone number stays optional -- clearing it is how a number comes off file -- but a
 * number that is there has to look like one.
 */
export const createProfileSchema = (translate: TranslateFn) => yup.object({
    firstName: personName(translate,
        ResourcesIds.FIRST_NAME_REQUIRED, ResourcesIds.FIRST_NAME_VALIDATION_ERROR)
        .max(NAME_MAX, translate(ResourcesIds.CLINIC_FIELD_TOO_LONG, { max: NAME_MAX })),
    lastName: personName(translate,
        ResourcesIds.LAST_NAME_REQUIRED, ResourcesIds.LAST_NAME_VALIDATION_ERROR)
        .max(NAME_MAX, translate(ResourcesIds.CLINIC_FIELD_TOO_LONG, { max: NAME_MAX })),
    phoneNumber: phoneNumber(translate, ResourcesIds.PHONE_NUMBER_INVALID),
});
